/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ClaimRewardsRequestBody,
  ClaimRewardsResponse,
  CreateRewardCodeRequest,
  CreateRewardCodeResponse,
} from '../models';
import {
    ClaimRewardsRequestBodyFromJSON,
    ClaimRewardsRequestBodyToJSON,
    ClaimRewardsResponseFromJSON,
    ClaimRewardsResponseToJSON,
    CreateRewardCodeRequestFromJSON,
    CreateRewardCodeRequestToJSON,
    CreateRewardCodeResponseFromJSON,
    CreateRewardCodeResponseToJSON,
} from '../models';

export interface ClaimRewardsRequest {
    reward: ClaimRewardsRequestBody;
}

export interface CreateRewardCodeOperationRequest {
    createRewardCodeRequest: CreateRewardCodeRequest;
}

/**
 * 
 */
export class RewardsApi extends runtime.BaseAPI {

    /**
     * @hidden
     * Claims all the filtered undisbursed rewards for a user
     */
    async claimRewardsRaw(params: ClaimRewardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimRewardsResponse>> {
        if (params.reward === null || params.reward === undefined) {
            throw new runtime.RequiredError('reward','Required parameter params.reward was null or undefined when calling claimRewards.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/rewards/claim`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClaimRewardsRequestBodyToJSON(params.reward),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimRewardsResponseFromJSON(jsonValue));
    }

    /**
     * Claims all the filtered undisbursed rewards for a user
     */
    async claimRewards(params: ClaimRewardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimRewardsResponse> {
        const response = await this.claimRewardsRaw(params, initOverrides);
        return await response.value();
    }

    /**
     * @hidden
     * Creates a new reward code with Solana signature verification
     */
    async createRewardCodeRaw(params: CreateRewardCodeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateRewardCodeResponse>> {
        if (params.createRewardCodeRequest === null || params.createRewardCodeRequest === undefined) {
            throw new runtime.RequiredError('createRewardCodeRequest','Required parameter params.createRewardCodeRequest was null or undefined when calling createRewardCode.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/rewards/code`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateRewardCodeRequestToJSON(params.createRewardCodeRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateRewardCodeResponseFromJSON(jsonValue));
    }

    /**
     * Creates a new reward code with Solana signature verification
     */
    async createRewardCode(params: CreateRewardCodeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateRewardCodeResponse> {
        const response = await this.createRewardCodeRaw(params, initOverrides);
        return await response.value();
    }

}
